import { render, staticRenderFns } from "./ShippingDetailsDiaolog.vue?vue&type=template&id=ccb9b754&scoped=true&"
import script from "./ShippingDetailsDiaolog.vue?vue&type=script&lang=js&"
export * from "./ShippingDetailsDiaolog.vue?vue&type=script&lang=js&"
import style0 from "./ShippingDetailsDiaolog.vue?vue&type=style&index=0&id=ccb9b754&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccb9b754",
  null
  
)

export default component.exports